module.exports = __webpack_public_path__ + "img/1_icn_sneaker_selezionata_bak.1d73d90a.png";